<div dir="rtl">
  <mat-dialog-content>
    <h3 style="font-size: medium;width:100%;text-align: center;">تنظیمات ستون های جدول</h3>
    <hr class="mt-0 mb-0" />
    <div class="w-100">
      <div>

        <table>
          <tr *ngFor="let column of elements; let i = index">

            <td>
              <div class="col_title w-100 text-end"> {{i+1}} . {{ getTitle(column.name) }}</div>
            </td>
            <td>

              <button class="up-button" [disabled]="!column.sortable" mat-button (click)="moveColumnUp(i)">↑</button>
              <button class="down-button" [disabled]="!column.sortable" mat-button
                (click)="moveColumnDown(i)">↓</button>
            </td>

            <td><mat-slide-toggle [disabled]="!column.hideable" (change)="Toggle(column.name,!column.isHiden)"
                color="info" [checked]="!column.isHiden"></mat-slide-toggle>  </td>
          </tr>

        </table>

      </div>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <div class="w-100 px-2 pt-2 pb-4 text-center border-top">
      <button class="btn pb-2" style="width:7rem;background-color: #08315b;border:1px solid gray;color:#fff"
        [mat-dialog-close]="true" (click)="onSaveClick()">ذخیره</button>
      <button id="cancelBtn" class="btn pb-2" style="width:7rem;border:1px solid gray;margin-right: 1rem;color:#000"
        (click)="onNoClick()">انصراف</button>
    </div>

  </mat-dialog-actions>
</div>
